import getById from 'utils/DOM/getById'
import innerHTML from 'utils/DOM/innerHTML'
import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'
import isRXPlan from 'utils/pivot/plan/isRXPlan'
import isEpicPlan from 'utils/pivot/plan/isEpicPlan'
import getGenericPlanBenefits from 'utils/pivot/plan/getGenericPlanBenefits'
import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import getTitlePlan from 'core/controllerPlans/getTitlePlan'
import getBadgeDental from 'core/controllerPlans/getBadgeDental'
import forEach from 'utils/DOM/forEach'
import detailsDentalFees from 'core/controllerPlans/detailsDentalFees'
import { numberToCurrency } from '@hc-frontend/utils'
import isPlanPPO from 'utils/pivot/plan/isPlanPPO'
import renderMembersSection from './renderMembersSection'

const asMoneyWithoutDecimal = numberToCurrency

function setBrochure(brochures, selector, plan) {
  forEach(selector, node => {
    node.href = brochures[plan.brochureId]
  })
}

function renderLegacyStyle(state) {
  const {
    hcStorage,
    plans,
    plan,
    dentalPlanId,
    visionPlanId,
    latitudeId,
    supplementalId,
    carriers,
    totalProducts
  } = state

  const dentalPlan = plans[dentalPlanId]
  const visionPlan = plans[visionPlanId]
  const supplementalPlan = plans[supplementalId]
  const latitudePlan = plans[latitudeId]

  // Attach core benefits
  const coreDetailsTemplate = Templater(getById('plan-benefit-template').innerText)
  const pointerNode = getById('plan-price-item')
  pointerNode.insertAdjacentHTML(
    'beforebegin',
    getGenericPlanBenefits(plan)
      .map(benefit => coreDetailsTemplate(benefit))
      .join('')
  )

  const isEpic = isEpicPlan(plan)
  const isRX = isRXPlan(plan)

  const planName =
    plan.planName +
    (state.isExtendedPlan ? ` Added Coverage to ${state.periodRange.days} Days` : '')
  textContent('.js-plan-name', planName)

  const node = document.querySelector('.js-plan-name--title')
  const planNameTooltip = getTitlePlan(plan)
  if (planNameTooltip) {
    node.title = planNameTooltip
  } else {
    toggleClass(node, 'd-none', true)
  }

  forEach('.js-rx', node => toggleClass(node, 'd-none', !isRX))

  setBrochure(state.brochures, '.js-brochure', plan)

  forEach('.js-plan-logo', node => {
    node.alt = carriers[plan.carrierId].name + ' | PivotHealth'
    node.src = carriers[plan.carrierId].logo
  })

  // dental section
  if (dentalPlan) {
    textContent('.js-addon-title', state.dentalVisionTitle)
    textContent('.js-prices-addOn', state.prices.dentalVision)

    innerHTML('.js-detailsFees', detailsDentalFees(dentalPlan, visionPlan))
    setBrochure(state.brochures, '.js-dental-brochure', dentalPlan)

    const badgeData = getBadgeDental(state.dentalVisionTitle, hcStorage.members)
    toggleClass('#tooltip-badge', 'd-none', badgeData.hideTooltip)
    textContent('.js-dental-badge', badgeData.message)
  }

  // latitude
  if (latitudePlan) {
    textContent('.js-latitude-title', latitudePlan.planName)
    textContent(
      '.js-accident',
      asMoneyWithoutDecimal(+latitudePlan.coreBenefits.accident)
    )
    textContent(
      '.js-critical-illness',
      asMoneyWithoutDecimal(+latitudePlan.coreBenefits.criticalIllness)
    )
    textContent(
      '.js-accidental-death',
      asMoneyWithoutDecimal(+latitudePlan.coreBenefits.accidentalDeath)
    )
    textContent(
      '.js-hospital-benefits',
      `${asMoneyWithoutDecimal(+latitudePlan.coreBenefits.hospitalBenefits)}/day`
    )

    textContent('.js-prices-latitude', state.prices.latitude)
    setBrochure(state.brochures, '.js-latitude-brochure', latitudePlan)
  }

  // supplemental
  if (supplementalPlan) {
    textContent('.js-prices-supplemental', state.prices.supplemental)
  }

  // general section

  textContent('.plan__applicant-edit', 'Edit')

  toggleClass('body', 'no-add-on', totalProducts === 1)

  if (isEpic) {
    let text = ''

    if (isPlanPPO(plan)) {
      text += isRX ? 'AH-2091 Epic PPO with RX' : 'AH-2092 Epic PPO without RX'
    } else {
      text += isRX ? 'AH-2090 Epic base with RX' : 'AH-2093 Epic base without RX'
    }

    innerHTML('#epic-plan-id', text)
  }
  renderMembersSection(state.hcStorage)

  toggleClass('body', 'show-loading', false)
  toggleClass('#js-plan-info', 'd-none', false)
}

export default renderLegacyStyle
